import { googleSvg } from "utils/assets_exports/images";
import { CustomComponentProps } from "utils/types/generalTypes";

const GoogleBtn = ({ className, style }: CustomComponentProps) => {
    return (
        <div className={`field ${className}`} style={style}>
            <div className="control">
                <a
                    href="#"
                    className="button raised is-rounded is-fullwidth d-flex gap-5"
                >
                    <img
                        src={googleSvg}
                        alt="G"
                        style={{ width: "22px", height: "22px" }}
                    />
                    Sign up with Google
                </a>
            </div>
        </div>
    );
};

export default GoogleBtn;
